import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { flexColumn } from '@/styles/common';

import { MAX_NUMBER_LENGTH } from './ExtraContent.constants';

export const DepositCard = styled.div`
  padding: 30px;
  border-radius: 28px;
  background-color: var(--bg-main);
  ${flexColumn};
  gap: 20px;
`;

export const Balance = styled.label`
  display: flex;
  width: fit-content;
  padding-bottom: 2px;
  border-bottom: 2px solid var(--bg-premium);
`;

export const ChipsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  & > * {
    width: 100% !important;
    justify-content: center;
    align-items: center;
  }
`;

export const BalanceInput = styled.input.attrs({ inputMode: 'numeric' })<{
  $charactersLength: number;
}>`
  all: unset !important;
  font-size: 30px !important;
  font-weight: 700 !important;
  color: var(--textAndLabels-main);

  width: ${({ $charactersLength }) =>
    `calc(${$charactersLength}ch + ${$charactersLength === MAX_NUMBER_LENGTH ? 1 : 0.5}ch)`} !important;
`;

export const AfterTopUpText = styled(Typography).attrs<{ $isDanger: boolean }>({
  variant: 'title5'
})`
  color: ${({ $isDanger }) =>
    $isDanger
      ? 'var(--textAndLabels-rejected)'
      : 'var(--textAndLabels-tertiary)'};

  font-weight: 400;
`;

export const DepositContainer = styled.div`
  ${flexColumn};
  gap: 10px;
`;
